//#region imports
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DetailsComponentModel } from '../../details.model';
import { DetailsService } from 'src/app/services/details.service';
import { NotificationService } from './../../../../services/notification.service';
import { SectionService } from 'src/app/services/section.service';
import { Globals } from 'src/app/services/globals';
//#endregion

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetailsComponent implements OnInit {
  //#region variables
  disableDetailsNext = false;
  detailsSectionFromGuarantee: boolean;
  detailsComponent: DetailsComponentModel;
  //#endregion

  //#region methods
  constructor(
    private detailsService: DetailsService, private notificationService: NotificationService,
    private sectionService: SectionService, private globals: Globals) { }

  ngOnInit() {
    const isRetrieveSimulation = this.sectionService.getIsRetrieveSimulation();
    if (isRetrieveSimulation) {
      this.detailsService.setDetailsProgressBarDetails();
      if(this.globals.isMobile)
      {this.detailsService.setmobileDetailsProgressBarDetails();}
      this.sectionService.setIsRetrieveSimulation(false);
    }
    this.detailsService.getDisableDetailsNext().subscribe((value) => {
      this.disableDetailsNext = value;
    });
    this.detailsService.getDetailsComponent().subscribe((value) => {
      this.detailsComponent = value;
    });
    this.globals.charpage1=this.globals.charpage2=this.globals.charpage3=this.globals.charpage4 =this.globals.charpage5 = false;
  }

  saveDialog() {
    this.notificationService.saveDialog();
  }
  //#endregion
}
